import { render } from "./DamageReportSK.vue?vue&type=template&id=deddf120&scoped=true"
import script from "./DamageReportSK.vue?vue&type=script&lang=ts"
export * from "./DamageReportSK.vue?vue&type=script&lang=ts"

import "./DamageReportSK.vue?vue&type=style&index=0&id=deddf120&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-deddf120"

export default script